export const nav = {
  namespaced: true,
  state: {
    drawer: false
  },
  actions: {
    clear: (context: any) => {
      context.commit('clear');
    },      
    login({ commit }: any, user: any) {
      commit('toggleSidebar');
    },
  },
  mutations: {
    clear(state: any) {
      state.drawer = false;
    },
    toggleSidebar(state: any) {
      state.status.drawer = !state.status.drawer;
    }
  }
};

export default nav;